import type { ETA_ADVISER_PLACEHOLDERS_OBJECT, TEMPLATE_TYPE } from 'cpool-constants';
import { ETA_PLACEHOLDER, SALUTATIONS } from 'cpool-constants';
import type {
    MailHeaderFooterPart,
    SchemaTemplateResolver_GetFooters,
    SchemaTemplateResolver_GetHeaders,
    SchemaTemplateResolver_GetSignature,
    SchemaUserResolver_Get,
} from 'cpool-tables/backend-resolvers';
import { getTitleCase } from 'cpool-utils';

import { GENDERS_SHORTHAND } from '~/constants';
import type { InputKind } from '~/features/headerFooterTemplate/types';
import { renderPreviewEtaMailTemplate } from '~/utils/mailTemplates/renderPreviewEtaMailTemplate';

type Props = {
    contentKind: InputKind;
    mailContent:
        | SchemaTemplateResolver_GetHeaders
        | SchemaTemplateResolver_GetSignature
        | SchemaTemplateResolver_GetFooters
        | { data: MailHeaderFooterPart; type: TEMPLATE_TYPE }
        | null;
    user: SchemaUserResolver_Get | undefined;
};

export const formatEtaHeaderFooterSignatureContent = ({ contentKind, mailContent, user }: Props) => {
    if (!user || !mailContent) return '';

    const etaContext = {
        [ETA_PLACEHOLDER.ANREDE_BERATER]:
            user.gender === GENDERS_SHORTHAND.m
                ? getTitleCase(SALUTATIONS.HERR) ?? ''
                : getTitleCase(SALUTATIONS.FRAU) ?? '',
        [ETA_PLACEHOLDER.EMAIL_BERATER]: user.email,
        [ETA_PLACEHOLDER.NACHNAME_BERATER]: user.lastName,
        [ETA_PLACEHOLDER.TELEFON_BERATER]: user.phone ?? '',
        [ETA_PLACEHOLDER.TITEL_BERATER]: user.title,
        [ETA_PLACEHOLDER.VORNAME_BERATER]: user.firstName,
    } satisfies ETA_ADVISER_PLACEHOLDERS_OBJECT;

    const { renderedText: convertedMailContent } = renderPreviewEtaMailTemplate({
        contentKind,
        etaContext,
        isOfferTemplate: false,
        template: mailContent.data[contentKind],
        templateType: mailContent.type,
    });

    return convertedMailContent;
};
